import apiClient from "./apiClient";

const list = async (params = {}) => {
  const response = await apiClient.get("/farmaci", { params });
  return response.data;
};

const FarmaciService = {
  list,
};

export default FarmaciService;

